export enum STORE {
  CONTACT = 'Contact',
  CAMPAIGN = 'Campaign',
  CAMPAIGN_SETTINGS = 'CampaignSettings',
  CSV = 'Csv',
  PHONE_CSV = 'PhoneCsv',
  PHONE = 'Phone',
  CALL_CENTER = 'CallCenter',
  LEAD_LIST = 'LeadList',
  RULE = 'Rule',
  IVR = 'Ivr',
  LEAD = 'Lead',
  LEAD_ITEM = 'LeadItem',
  LEAD_LIST_ITEM = 'LeadListItem',
  TARGET = 'Target',
  FLOW = 'Flow',
  CAMPAIGN_EXPORT = 'CampaignExport',
  COMPANY = 'Company',
  EVENT_LOG = 'EventLog',

  // for testing only
  TEST = 'Test',
  TEST_2 = 'Test2',
}
